import { DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { HeaderComponent } from '@app/_core/components/header/header.component';
import { UserService } from '@app/_core/services/user.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-edit-avatar',
  templateUrl: './edit-avatar.component.html',
  styleUrls: ['./edit-avatar.component.scss'],
})
export class EditAvatarComponent implements OnInit {
  ngOnInit(): void {}
  @Output() ImageFileURL: EventEmitter<any> = new EventEmitter();

  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private HeaderComponent: HeaderComponent,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private userService: UserService
  ) {
    this.appBaseUrl = window.location.origin +'/'+ window.location.pathname.split('/')[1];
   // console.log('appBaseUrl', this.appBaseUrl);
  }
  file: File = null;
  files: any = [];
  blobData: any;
  fileID: any = '';
  ImageURL: any = '';
  savingFileMessage: any = '';
  appBaseUrl: any;
  URL: any = '';
  closeEditAvatarPopup() {
    this.bsModalRef.hide();
  }
  goBack() {
    this.bsModalRef.hide();
  }
  filesDropped(files: any): void {
    this.files = files;
   // console.log(files.size + 'size');
  }
  UpdateAvatar() {
    //console.log(this.files, 'filecheck');
    if (this.files.length === 0) {
      alert('Select valid image file');
      return;
    }
    this.fileID = this.savefile();
    //console.log('uploadfilefileID', this.fileID);
    this.bsModalRef.hide();
    return this.ImageURL;
  }
  savefile() {
    this.blobData = this.files;
    const fil: string = this.files;
    this.userService.saveFile(this.files, 'jpg', false).subscribe(response => {
      this.fileID = response.Response.Data.FileID;
     // console.log(this.fileID + 'saveFileresponse', response);
      this.savingFileMessage = 'File Saved';
      this.uploadfile(this.fileID);
      return response.Response.Data.FileID;
    });
  }
  uploadfile(fileID: any) {
   // console.log('uploadfilefileIDfileIDfileID', fileID);
    this.userService.uploadFile(fileID).subscribe(response => {
     // console.log('uploadfile', response.Response.Data.URL);

      this.ImageURL = response.Response.Data.URL;
     // console.log(this.ImageURL + 'this.URL');
      this.ImageFileURL.emit(this.ImageURL);
      this.savingFileMessage = 'File Saved';
      this.HeaderComponent.getAvatar();
    });
  }
}
